import * as React from 'react';
import { ModalWindow, RadioGroup, IconSort16 } from '@cian/ui-kit';
import { ESorting } from '../../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { trackSortingChange } from './tracking';
import { getSortingNames } from '../../../utils/sorting';
import * as styles from './SortingMobile.css';

export interface ISortingProps {
  onSelect(key: string): void;
  regionHasRoads: boolean;
  regionHasStations: boolean;
  regionId: number;
  sorting: ESorting;
}

export interface ISortingState {
  isModalOpen: boolean;
}

export class SortingMobile extends React.Component<ISortingProps, ISortingState> {
  public state = {
    isModalOpen: false,
  };

  public render() {
    const { regionId, regionHasRoads, regionHasStations, sorting } = this.props;
    const { isModalOpen } = this.state;
    const sortingParams = {
      regionHasRoads,
      regionHasStations,
      regionId,
    };
    const sortingNames = getSortingNames(sortingParams);

    const options = Object.keys(sortingNames)
      .map(name => {
        return {
          label: sortingNames[name] || '',
          value: name,
        };
      })
      .filter(option => option.label);

    return (
      <>
        <ModalWindow title="Сортировка" open={isModalOpen} onClose={this.close}>
          <div className={styles['content']}>
            <RadioGroup options={options} value={sorting} onChange={this.handleClickOnItem} />
          </div>
        </ModalWindow>
        <button className={styles['button']} data-name="SortButton" onClick={this.handleClickOnLink}>
          <div className={styles['button-text']}>{sortingNames[sorting]}</div>
          <IconSort16 color="primary_100" />
        </button>
      </>
    );
  }

  private close = () => {
    this.toggle(false);
  };

  private toggle = (isModalOpen = !this.state.isModalOpen) => {
    this.setState({ isModalOpen });
  };

  private handleClickOnLink = () => {
    this.toggle();
  };

  private handleClickOnItem = (_e: React.ChangeEvent<HTMLInputElement>, item: string) => {
    if (this.props.sorting === item) {
      return this.close();
    }
    trackSortingChange(item);
    this.props.onSelect(item);
    this.close();
  };
}
